import { statusFilterOptions } from 'utils/selectOptionsUtils';

import FilterDropdownCard from 'components/Filter/FilterDropdownCard';
import FilterSearchCard from 'components/Filter/FilterSearchCard';

interface IProgressBarsFiltersProps {
  isVisible: boolean;
  skuFilterValue: string;
  setSkuFilterValue: (value: string) => void;
  statusFilterValue: string;
  setStatusFilterValue: (value: string) => void;
}

export const ProgressBarsFilters = ({
  isVisible,
  skuFilterValue,
  setSkuFilterValue,
  statusFilterValue,
  setStatusFilterValue
}: IProgressBarsFiltersProps): React.ReactElement | null => {
  if (!isVisible) {
    return null;
  }

  return (
    <div className="flex px-9 gap-3">
      <FilterSearchCard
        header="External ID"
        filterValue={skuFilterValue}
        setFilterValue={setSkuFilterValue}
        isLabelSearchBy
      />
      <FilterDropdownCard
        header="Status"
        filterValue={statusFilterValue}
        setFilterValue={setStatusFilterValue}
        options={statusFilterOptions}
      />
    </div>
  );
};
